__turbopack_context__.v({
  "arrivalPulse": "hero-flow-module__NknbtW__arrivalPulse",
  "art": "hero-flow-module__NknbtW__art",
  "branch": "hero-flow-module__NknbtW__branch",
  "check": "hero-flow-module__NknbtW__check",
  "core": "hero-flow-module__NknbtW__core",
  "coreGlow": "hero-flow-module__NknbtW__coreGlow",
  "destination": "hero-flow-module__NknbtW__destination",
  "destinationRing": "hero-flow-module__NknbtW__destinationRing",
  "destinationSurface": "hero-flow-module__NknbtW__destinationSurface",
  "featuredOrigin": "hero-flow-module__NknbtW__featuredOrigin",
  "figure": "hero-flow-module__NknbtW__figure",
  "flow": "hero-flow-module__NknbtW__flow",
  "heading": "hero-flow-module__NknbtW__heading",
  "keywords": "hero-flow-module__NknbtW__keywords",
  "origin": "hero-flow-module__NknbtW__origin",
  "originCenter": "hero-flow-module__NknbtW__originCenter",
  "orkestArrivalRipple": "hero-flow-module__NknbtW__orkestArrivalRipple",
  "orkestPathDataFlow": "hero-flow-module__NknbtW__orkestPathDataFlow",
  "sales": "hero-flow-module__NknbtW__sales",
  "salesBody": "hero-flow-module__NknbtW__salesBody",
  "salesTitle": "hero-flow-module__NknbtW__salesTitle",
});
